import { render, staticRenderFns } from "./Plank.vue?vue&type=template&id=37fb79ba&scoped=true"
import script from "./Plank.vue?vue&type=script&lang=ts"
export * from "./Plank.vue?vue&type=script&lang=ts"
import style0 from "./Plank.vue?vue&type=style&index=0&id=37fb79ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb79ba",
  null
  
)

export default component.exports